import React from 'react';
import includes from 'lodash/includes';

import { LabeledCheckbox } from 'components/shared/checkbox';
import Table from 'components/shared/table';
import ArchivesTitleCell from './cells/title';
import ArchivesDateCell from './cells/archived_at';
import ArchivesActivityCell from './cells/activity';

const isArchivableSelected = (items, index) => includes(items, index);

const ArchivesRow = ({
  index,
  type,
  archivable,
  selectedArchivables,
  toggleArchivable,
  bulkActionStatus,
  canUnarchive,
}) => {
  const { inProgress, success } = bulkActionStatus;
  const selected = isArchivableSelected(selectedArchivables, index);

  const shouldDisableCheckbox =
    (selected && (inProgress || success)) ||
    (!canUnarchive && ['user', 'group', 'group::smart'].includes(type));

  return (
    <Table.Row selected={selected}>
      <Table.BodyCell size="xs">
        <LabeledCheckbox
          checked={selected}
          disabled={shouldDisableCheckbox}
          onChange={() => toggleArchivable(index)}
          className="u-margin-0"
          ariaLabel={t('common.select')}
        />
      </Table.BodyCell>
      <ArchivesTitleCell {...archivable} selected={undefined} />
      <ArchivesDateCell {...archivable} />
      <ArchivesActivityCell {...archivable} />
    </Table.Row>
  );
};

export default ArchivesRow;
